import { DateFilterTypeEnum } from "./types";

const filters = [
  { label: "dashboard.all", value: DateFilterTypeEnum.ALL },
  { label: "dashboard.today", value: DateFilterTypeEnum.TODAY },
  { label: "dashboard.week", value: DateFilterTypeEnum.WEEK },
  { label: "dashboard.lastMonth", value: DateFilterTypeEnum.MONTH },
  { label: "dashboard.year", value: DateFilterTypeEnum.YEAR },
];


export { filters };

